import { formFieldFactory } from '@treneo/shared/forms';

import type { CourseFormData } from './types';

const courseFormField = formFieldFactory<CourseFormData>();

export const courseFormFieldNames = {
  title: courseFormField('title'),
  description: courseFormField('description'),
  courseDates: courseFormField('courseDates'),
  daOrganizationId: courseFormField('daOrganizationId'),
  trainerEmail: courseFormField('trainerEmail'),
  pendingTrainerInviteEmails: courseFormField('pendingTrainerInviteEmails'),
  trainerUserId: courseFormField('trainerUserId'),
  timezone: courseFormField('timezone'),
  expectedParticipants: courseFormField('expectedParticipants'),
  maxParticipants: courseFormField('maxParticipants'),
  daDataCenterIds: courseFormField('daDataCenterIds'),
  wantToBeCoordinator: courseFormField('wantToBeCoordinator'),
  isDemo: courseFormField('isDemo')
} as const;
